import { useCustom } from '@refinedev/core';
import { Card, Typography } from 'antd';
import { Column } from '@ant-design/charts';
import type { RatingBucketOut } from '@/api/generated/schemas';

export const RatingDistribution = () => {
  const { query } = useCustom<RatingBucketOut[]>({
    url: 'feedback/reviews/stats/ratings',
    method: 'get',
  });

  const data = (query.data?.data ?? []) as RatingBucketOut[];

  return (
    <Card title="Rozkład ocen" loading={query.isLoading}>
      {data.length > 0 ? (
        <Column
          data={data}
          xField="rating"
          yField="count"
          height={240}
          label={{ position: 'top' }}
          meta={{
            rating: { alias: 'Ocena' },
            count: { alias: 'Liczba recenzji' },
          }}
        />
      ) : (
        <Typography.Text type="secondary">Brak danych</Typography.Text>
      )}
    </Card>
  );
};
